import _ from 'lodash'

/**
 * Resource that represents a Hierarchy.
 *
 * @name Hierarchy
 * @class
 * @augments TmrResource
 */
function HierarchyFactory(
  TmrTransformResourceAction,
  TmrResource,
  tmrLimitZeroWorkaround
) {
  'ngInject'
  let actions = {
    /**
     * Loads all hierarchies then groups them by parent.
     *
     * @method Hierarchy#getTree
     */
    getTree: {
      method: 'GET',
      isArray: true,
      params: { limit: tmrLimitZeroWorkaround },
    },
  }
  TmrTransformResourceAction.appendResponse(actions.getTree, _.tree)
  return TmrResource('Hierarchy', actions)
}

export const factory = ['Hierarchy', HierarchyFactory]
